<template>
  <div class="move-credentials card-wrapper">
    <div class='move-credentials__top'>
      {{ $t('digitalServices.move.credentials.title') }}
    </div>
    <validation-observer
      ref='moveCredentials'
      tag='div'
      class='move-credentials__container'>
      <div class='move-credentials__item'>
        <div class='move-credentials__item-title'>
          {{ $t('digitalServices.move.credentials.username') + ':' }}
        </div>
        <div class='move-credentials__item-value'>
          {{ username }}
        </div>
      </div>
      <div class='move-credentials__item'>
        <template v-if='!isEditMode'>
          <div class='move-credentials__item-title'>
            {{ $t('registration.passwordLabel') + ':' }}
          </div>
          <div class='move-credentials__item-value'>
            <span>{{ password }}</span>
          </div>
        </template>
        <base-v-input v-else v-model.trim="passwordInput"
                      class="move-credentials__item-value-input"
                      id="movePassword"
                      container-class="password-input"
                      name="movePassword"
                      rules="required|movePassword"
                      maxlength="20"
                      vid="password"
                      ref="password" />
      </div>
      <div class='move-credentials__item'>
        <div class='move-credentials__item-title'>
            {{ $t('digitalServices.move.credentials.changePassword') }}

            <i
              class="move-credentials__item-icon icon-sc-edit"
              @click='changeMovePassword'></i>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import errorMessageHandler from '../../mixins/errorMessageHandler'

export default {
  name: 'move-credentials',
  mixins: [errorMessageHandler],
  props: {
    username: {
      type: String,
      default: ''
    },
    password: {
      type: String,
      default: ''
    },
    moveServiceId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isEditMode: false,
      passwordInput: ''
    }
  },
  methods: {
    async changeMovePassword () {
      if (this.isEditMode) {
        const isValid = await this.$refs.moveCredentials.validate()

        if (isValid) {
          const dataToSend = {
            moveServiceId: this.moveServiceId,
            newPassword: this.passwordInput,
            username: this.username
          }

          this.$apiRequest.post('/user/move/changepassword', dataToSend)
            .then(() => {
              this.passwordInput = ''
              this.toast('success', {
                title: this.$t('toastMessages.movePasswordChangedNotification')
              })
              this.$parent.$parent.fetchMovePackages()
            })
            .catch(e => {
              this.handleErrorMessage(e.response.data)
            })
            .finally(() => {
              this.isEditMode = false
            })
        }
      } else this.isEditMode = true
    }
  }
}
</script>

<style scoped lang="scss">
.move-credentials {
  padding: 16px;
  display: flex;
  flex-direction: column!important;

  &__top {
    padding-bottom: 16px;
    border-bottom: 1px solid $grey;
    font-weight: 600;
    font-size: 16px;
  }

  &__container {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
    justify-content: space-between;
    align-items: center;

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    margin-bottom: 16px;

    &:first-child {
      width: 100%;
    }

    @media (map_get($breakpoints, sm)) {
      margin-bottom: 0;

      &:first-child {
        width: auto;
      }
    }
  }

  &__item-title {
    color: $dark-grey;
  }

  &__item-value {
    font-weight: 600;
  }

  &__item-icon {
    color: $mtel-red;
    cursor: pointer;
  }

  &__item-value-input {
    min-width: 200px;
  }
}
</style>
